var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('MobileTopPart'),_c('v-row',[_c('v-col',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"px-5 pt-5 py-3",attrs:{"cols":"12"}},[_c('SearchForm')],1),_c('v-col',{staticClass:"white"},[(_vm.$store.state.progressSearching)?_c('MyLoader',{style:({
                marginTop: '150px',
              })}):_c('List')],1)],1)],1)],1)],1),_c('v-row',[_c('PageFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }